import React, { useState } from "react";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import { Colors } from "../../../../utils/colors/colors";
import FormInput from "./FormInput";
import Services from "./Services";
import { validateEmail } from "../../../../validations/emailValidator";
import ContactSuccess from "./ContactSuccess";
import { toast } from "react-toastify";
import ContactService from "../../../../assets/services/contact";





export default function FormContainer() {
  const [name, setName] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [projectDescription, setProjectDescription] = useState<string>("");
  const [serviceType, setServiceType] = useState<string[]>([]);
  const [statusMessage, seStatusMessage] = useState<string>("");
  const [isSucceeded, setIsSucceeded] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { whiteColor } = Colors();


  const handleContact = async () => {
    setIsLoading(true);

    let response = await ContactService({
      name,
      emailAddress,
      companyName,
      serviceType,
      projectDescription,
    })

    setIsSucceeded(response.isSucceeded)
    seStatusMessage(response.statusMessage)
    setIsLoading(response.isLoading)
    console.log(response);

    return response;
  }



  const handleSubmit = (e: any) => {
    e.preventDefault();


    const emailIsValid = validateEmail(emailAddress);
    if (!emailIsValid) {
      toast.warning("Please input a valid email address");
    } else {
      handleContact();
    };
  };




  return (
    <div className="form-container" data-aos="fade-up" data-aos-once="true">

      {
        isSucceeded ? (<ContactSuccess />)
          :
          (<form onSubmit={handleSubmit}>
            <div className="form-content">
              <Services
                setServiceType={setServiceType}
                serviceType={serviceType}
              />
              <FormInput
                placeholder={"Name"}
                name={"name"}
                type={"text"}
                id={""}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <FormInput
                placeholder={"Email address"}
                name={"email"}
                type={"email"}
                id={""}
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
              />

              <FormInput
                placeholder={"Company name"}
                name={"company-name"}
                type={"text"}
                id={""}
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />

              <FormInput
                placeholder={"Message"}
                name={"project-description"}
                type={"text"}
                id={""}
                value={projectDescription}
                onChange={(e) => setProjectDescription(e.target.value)}
                style={{
                  height: "88px",
                }}
              />

              <ButtonComponent
                bgColor={whiteColor}
                text={isLoading ? "Submitting ..." : "Send Message"}
                style={{
                  marginTop: "4rem",
                  fontSize: "1rem"
                }}
                click={handleSubmit}
                isLoading={isLoading}
              />
            </div>
            {statusMessage && (
              <div
                className="errorMsg subtitle mt-0 mb-3 mx-3"
                style={{ fontSize: "1rem" }}
              >
                {statusMessage}
              </div>
            )}
          </form>)
      }
    </div>
  );
}